import { STORAGE_KEY } from "@/constant/export/storage";
import { ASSISTANT_TAB_INSTANCE_KEY } from "./assistantStore";
import { createRandomId } from "./randomId";

const CLIENT_ID_PREFIX = import.meta.env.VITE_ABLY_CLIENT_ID_PREFIX ?? "hpoll-user";

const getOrCreateTabInstanceId = () => {
    if (typeof window === "undefined") return createRandomId("tab");
    try {
        const existing = sessionStorage.getItem(ASSISTANT_TAB_INSTANCE_KEY);
        if (existing) return existing;
        const id = createRandomId("tab");
        sessionStorage.setItem(ASSISTANT_TAB_INSTANCE_KEY, id);
        return id;
    } catch {
        return createRandomId("tab");
    }
};

const buildAssistantClientId = (userId) => {
    const safeUserId = (userId ?? "guest").toString().trim() || "guest";
    const tabInstanceId = getOrCreateTabInstanceId();
    return `${CLIENT_ID_PREFIX}--${safeUserId}--${tabInstanceId}`;
};

const resolveUserId = (userId) => {
    if (userId !== undefined && userId !== null && `${userId}`.trim() !== "") {
        return userId;
    }
    try {
        const storedUser = JSON.parse(localStorage.getItem(STORAGE_KEY.USER) || "{}");
        if (storedUser?.id !== undefined && storedUser?.id !== null) {
            return storedUser.id;
        }
    } catch {
    }
    return null;
};

export const ensureAssistantIdentity = ({ userId } = {}) => {
    const resolvedUserId = resolveUserId(userId);
    const clientId = buildAssistantClientId(resolvedUserId);
    return { clientId };
};

export const createAssistantMessageId = () => {
    return createRandomId("msg");
};
